export default {
  data() {
    return {
      exportForm: {},
    }
  },
  methods: {
    // async handleExport() {
    //   console.log("Desc", this.Desc)
    //   this.$prompt("请为导出的文件命名", "导出文件名", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //   })
    //     .then(async ({ value }) => {
    //       this.$message({
    //         type: "success",
    //         message: "下载导出文件，请访问 “操作历史” 页",
    //       });
    //       this.exportForm.filename = value;
    //       console.log("this.exportForm.filename", this.exportForm.filename);
    //       // 发请求
    //       await this._axios()
    //     })
    //     .catch((e) => {
    //       console.log("e", e)
    //       if (e === 'cancel') {
    //         this.$message({
    //           type: "info",
    //           message: "取消",
    //         });
    //       }
    //     });
    // },

    // async _axios() {
    //   let { data, err } = await this.axiosApi(
    //     this.Desc.export_api,
    //     this.exportForm
    //   );
    //   console.log("data 导出", data);
    // }
  }
}


// WEBPACK FOOTER //
// ./src/common/mixins/handle-export/index.js